<template>
    <div class="filters-preview">
        <ul>
            <li v-for="(filter, index) in activeFilters" :key="index">
                <div
                    class="filters-preview__tag typographies-paragraph-medium-regular"
                    @click="editFilter(filter)"
                    v-html="$filters.stripTags(filter.translation)"
                />
                <CompassIconButton
                    v-if="filterEditable(filter) && filter.deletable"
                    icon="close"
                    size="small"
                    @click.prevent="$store.dispatch(`${listinghash}/removeFilter`, filter)"
                />
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    props: {
        listinghash: {
            type: String,
            required: true,
        },
    },
    computed: {
        activeFilters() {
            return this.$store.getters[`${this.listinghash}/activeFilters`];
        },
    },
    methods: {
        filterEditable(filter) {
            return !_.has(this.$store.state[this.listinghash].prefilter, filter.name);
        },
        editFilter(filter) {
            if (!this.filterEditable(filter)) {
                return false;
            }

            return this.$store.dispatch(`${this.listinghash}/editFilter`, filter);
        },
    },
};
</script>

<style lang="scss" scoped>
.filters-preview {
    flex: 1;
    margin: 0 var(--spacing-1);

    ul {
        display: flex;
        gap: var(--spacing-1);
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    li {
        display: flex;
        align-items: center;
        border: 1px solid var(--colors-common-border-default, #ccccd1);
        background-color: var(--colors-component-background-information-tag-stroked, #ffffff);
        padding: 3px var(--spacing-0) 3px var(--spacing-1);
        color: var(--colors-common-text-standard-default, #111111);
        border-radius: var(--spacing-0);
    }

    &__tag {
        flex: 1;
        cursor: pointer;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-right: var(--spacing-1);
    }
}
</style>
